<div class="d-flex h-100 flex-column pb-2">
  @if (workflow !== undefined) {
    <app-header-bar
      [backRoute]="'/workflows'"
      [autoTranslateTitle]="false"
      [title]="workflow.name"
    ></app-header-bar>
  }
  <div class="editor-header-container mt-md-3 mb-1">
    @if (workflow) {
      <workflow-history-dropdown
        class="w-25"
        [workflowId]="workflow.id"
        (selected)="loadHistoryEntry($event)"
        >></workflow-history-dropdown
      >
    }
    <input
      #lineWrap
      class="form-check-input mb-2 ms-1 me-1"
      type="checkbox"
      value="1"
    />
    <label class="form-check-label me-auto">
      {{ 'workflow.line_wrap' | translate }}
    </label>
    <mat-button-toggle-group
      class="segmented-pill"
      name="toggle"
      [(ngModel)]="selected"
      (ngModelChange)="onSelectionChange($event)"
      appearance="standard"
      [hideSingleSelectionIndicator]="true"
      aria-label="Version view selector"
    >
      <mat-button-toggle value="draft">
        <mat-icon fontIcon="edit"></mat-icon>
        {{ 'workflow.draft' | translate }}
      </mat-button-toggle>

      <mat-button-toggle value="currentVersion">
        <mat-icon fontIcon="public"></mat-icon>
        {{ 'workflow.published-version' | translate }}
      </mat-button-toggle>

      <mat-button-toggle value="diff">
        <mat-icon fontIcon="difference"></mat-icon>
        {{ 'workflow.compare' | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <app-loading-indicator [loading]="loading"></app-loading-indicator>
  @if (selected === 'diff') {
    <ngx-monaco-diff-editor
      class="full-size flex-grow-1"
      #editor
      [options]="diffEditorOptions"
      [originalModel]="currentDefinitionModel"
      [modifiedModel]="draftModel"
    >
    </ngx-monaco-diff-editor>
  } @else {
    <ngx-monaco-editor
      class="full-size flex-grow-1"
      #editor
      [options]="editorOptions"
      [formControl]="editorCtrl"
    ></ngx-monaco-editor>
  }
  <div class="save-buttons-container">
    <input
      id="commitMessage"
      placeholder="{{ 'workflow.commit-message-placeholder' | translate }}"
      type="text"
      [(ngModel)]="commitMessage"
      [class.is-invalid]="commitMessageError && !commitMessage"
    />
    <button
      type="button"
      class="btn btn-workflow me-1"
      [class.fake-disabled]="!commitMessage?.trim()"
      (click)="saveDefinitionDraft()"
      data-spinner-color="#000"
      [ladda]="saving"
    >
      {{ 'workflow.save-draft' | translate }}
    </button>
    <div class="workflow-publish-flow">
      <button
        type="button"
        class="btn btn-workflow"
        (click)="checkChanges()"
        data-spinner-color="#000"
        [ladda]="saving"
      >
        {{ 'workflow.review' | translate }}
      </button>
      <span class="arrow" aria-hidden="true">➔</span>
      <button
        type="button"
        class="btn btn-publish-workflow me-1"
        [class.fake-disabled]="!commitMessage?.trim() || !changesChecked"
        (click)="publishButtonPressed()"
        data-spinner-color="#000"
        [ladda]="saving"
      >
        {{ 'workflow.publish' | translate }}
      </button>
    </div>
  </div>
  <app-error [error]="error"></app-error>

  <ng-template #publishConfirmationModal>
    <div class="modal-header">
      @if (workflow) {
        <h4 class="modal-title">{{ workflow.name }}</h4>
      }
      <button
        type="button"
        class="btn-close"
        (click)="modalRef?.close()"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <p>{{ 'workflow.publish-confirmation-dialog' | translate }}</p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="modalRef?.close()"
        data-spinner-color="#000"
        [ladda]="saving"
      >
        {{ 'cancel' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-warning"
        (click)="publishDraftAsDefinition()"
        data-spinner-color="#000"
        [ladda]="saving"
      >
        {{ 'workflow.publish' | translate }}
      </button>
    </div>
  </ng-template>
</div>
